<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
       
        <Row>
            <Col span="24">
                <FormItem label="黑名单名称:" prop="keyword" :class="{requireStar:true}" >
                  <Input v-model="formValidate.keyword"  ></Input>
                </FormItem>
            </Col>
        </Row>
         <Row >
            <Col span="24">
                  <FormItem label="分类:" prop="category">
                    <RadioGroup v-model="formValidate.category">
                      <Radio label="演出" >演出</Radio>
                      <Radio label="文化" >文化</Radio>
                      <Radio label="旅游" >旅游</Radio>
                      <Radio label="票务">票务</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
         <Row >
            <Col span="24">
                  <FormItem label="类别:" prop="blackType">
                    <RadioGroup v-model="formValidate.blackType">
                      <Radio label="小说" >小说</Radio>
                      <Radio label="动漫" >动漫</Radio>
                      <Radio label="音乐" >音乐</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
       <!--Row >
            <Col span="24">
                  <FormItem label="属性:" prop="tag">
                    <RadioGroup v-model="formValidate.tag">
                      <Radio label="耽美" >耽美</Radio>
                      <Radio label="邪典" >邪典</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </!--Row-->
        
       
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title:'',
      
        formValidate: {
          _id: '',
          keyword: '',
          category: '',
          blackType: '',
          tag:''
        },
        ruleValidate: {
          keyword: [{
            required: true,
            message: '黑名单名称不能为空',
            trigger: 'change'
          }],
           category: [{
            required: true,
            message: '类型不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
        if(row!=null){
          this.formValidate=row
          this.formValidate.blackType=row.type
        }
      },  
    
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  'api/blackList' 
            let myData = {
              type:1,
              _id: this.formValidate._id,
              keyword: this.formValidate.keyword,
              category: this.formValidate.category,
              blackType: this.formValidate.blackType,
              tag: this.formValidate.tag,
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
             if (response.data.code == 200) {
                this.$Message.success(response.data.msg);
                this.$parent.loadPage();
              } else {
                 this.$Message.error(response.data.msg);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/blacklist/BlackEdit.vue